import { PlcAnchor } from '../PlcAnchor/PlcAnchor.component';
import React from 'react';
import { PrimaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { urlEnum } from '@utils/url';
import classnames from 'classnames';

export const Subscribe = () => {
  const className = classnames('pro-btn', 'header-button');
  return (
    <PlcAnchor linkProps={{ href: urlEnum.landingPro }}>
      <PrimaryButton
        className={className}
        isPro
        isSmall
        textProps={{ i18nKey: 'common.abonner.header', variant: 'menu-link' }}
      />
    </PlcAnchor>
  );
};
